import React, { useEffect, useState } from "react";
import { AssortGroup } from "../../../models/AssortGroup";
import useTicketsByAssortGroup from "./hooks/useTicketsByAssortGroup";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import { HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useTranslation } from "react-i18next";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import getId from "../../../../utils/getId";

interface IProps {
  item: AssortGroup;
  sortType: "assortGroup" | "colorGroup" | "shapeGroup" | "colorGroupPasses" | "allParams";
  allParams?: any;
}

const LimitedTicketBlock: React.FC<IProps> = ({ item, sortType, allParams = {} }) => {
  const { t } = useTranslation();
  const {
    requestGetTicketsByAssortGroup,
    assorts,
    requestGetTicketsByColor,
    requestGetTicketsByShape,
    requestGetPassesByColor,
    requestGetTicketsByAllParams,
  } = useTicketsByAssortGroup();
  const [showTickets, setShowTicket] = useState(false);
  const isDesktop = useDesktopSize();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket } = usePreBasket();
  const { getBasket } = useBasketManager();
  const lowestPrice = assorts.reduce((r, b) => Math.min(r, b.price), Number.POSITIVE_INFINITY);
  const handleDeleteBasket = () => {
    clearBasket();

    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    if (sortType === "assortGroup") {
      requestGetTicketsByAssortGroup(item.objectId);
    }
    if (sortType === "colorGroup") {
      requestGetTicketsByColor(item.objectDb, item.objectId);
    }
    if (sortType === "shapeGroup") {
      requestGetTicketsByShape(item.objectId);
    }
    if (sortType === "colorGroupPasses") {
      requestGetPassesByColor(getId(item));
    }
    if (sortType === "allParams") {
      requestGetTicketsByAllParams(allParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.objectId]);

  const getButtonTitle = () => {
    if (showTickets) {
      return `${t("schowaj_bilety")} (${assorts.length})`;
    }
    return `${t("pokaz_bilety")} (${assorts.length})`;
  };

  const handleOpenExpanded = () => {
    if (showTickets) {
      setShowTicket(false);
    } else {
      setShowTicket(true);
    }
  };

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.pictureUrl}
        description={item.description}
        mainPrice={isDesktop ? `${t("ceny_od")} ${lowestPrice}` : `${t("od")} ${lowestPrice}`}
        buttonTitle={getButtonTitle()}
        buttonStartIcon={<HiOutlineTicket />}
        buttonVariant={showTickets ? "outlined" : "filled"}
        expanded={showTickets}
        onClick={handleOpenExpanded}
      >
        <div className="single-event-tickets">
          {assorts.map((itemTicket, index) => (
            <div className="ticket-line-container" key={index}>
              <TicketLineSummary
                item={itemTicket}
                preBasket={preBasket}
                addItemToBasket={addItemToBasket}
                removeItemFromBasket={removeItemFromBasket}
              />
            </div>
          ))}
          <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
        </div>
      </EAProductBanner>
    </>
  );
};

export default LimitedTicketBlock;
